//import spinner from './spinner';
import BaseComponent from '../base/baseComponent';
import customEventBus from '../libs/eventBus';
import micromodalInstance from '../libs/micromodalInstance';
import analyticsUtils from '../utilities/analyticsUtils';
export default class AddToWishlist extends BaseComponent {
    constructor(element) {
        super(element);
        this.isinwishlist = null;
        this.waiting = false;
        this.pid = this._options.vgid;
        this.pageType = document.querySelector('.page').getAttribute('data-action') || '';
        this.handleClick();
        // if (this.pageType === 'Wishlist-Show') {
        //   this.listenForCartAdded();
        // }
    }
    get SELECTORS() {
        return {
            label: '.btn-addtowishlist-label',
            feedback: '.btn-actions-feedback',
            listItem: '.product-tile',
            counter: 'data-wishlistcounter',
        };
    }
    handleClick() {
        this._el.addEventListener('click', (_e) => {
            this.count = document.body.querySelector(`[${this.SELECTORS.counter}]`)
                ? parseInt(document.body.querySelector(`[${this.SELECTORS.counter}]`).getAttribute(this.SELECTORS.counter))
                : 0;
            this.isinwishlist = JSON.parse(this._el.getAttribute('data-isinwishlist')) || false;
            this.wishlistFlow();
        });
    }
    async wishlistFlow() {
        if (this.waiting === false) {
            this.waiting = true;
            //spinner.set();
            try {
                const data = await this.toggleWishlist();
                const { error, msg } = data;
                if (data.nonAuthenticated) {
                    window.location.href = data.redirectUrl;
                    return;
                }
                if (error) {
                    console.error('wishlistFlow error', msg, error);
                }
                else if (data.listIsFull) {
                    console.warn('Wishlist is full');
                    //@ts-ignore
                    micromodalInstance.forceShow('modal-wishlistfull');
                }
                else {
                    analyticsUtils.updateDataLayer(this._el, data);
                    if (document.querySelector('.page').getAttribute('data-action') === 'Wishlist-Show') {
                        this.isinwishlist = false;
                        if (this.count > 0)
                            this.removeLisItemCard();
                        if (this.count < 1) {
                            location.reload();
                        }
                    }
                    else {
                        this.isinwishlist = !this.isinwishlist;
                        this.updateCta();
                    }
                    this.updateCounter(data.listLength);
                }
            }
            catch (error) {
                console.error('wishlistFlow error catch', error);
            }
            finally {
                //spinner.unset();
                this.waiting = false;
            }
        }
    }
    async toggleWishlist() {
        let endpointUrl, fetchData;
        // const formData = new FormData();
        // formData.append('pid', this.pid);
        let obj = { pid: this.pid };
        endpointUrl = this._options.endpointAdd;
        fetchData = {
            method: 'POST',
            body: JSON.stringify(obj),
            //body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        };
        return fetch(endpointUrl, fetchData).then(function (response) {
            // if (!this.isinwishlist && this.pageType === 'Product-Show') {
            //   customEventBus.emit(this.CUSTOM_MESSAGES.DATALAYER.WISHLIST.add, { trackUrl: location.href });
            // }
            return response.json();
        });
    }
    /****/
    updateCta() {
        this._el.setAttribute('data-isinwishlist', this.isinwishlist.toString());
        const copy = this.isinwishlist ? this._options.labelAdded : this._options.labelDefault;
        this._el.setAttribute('aria-label', copy);
    }
    removeLisItemCard() {
        this._el.closest(this.SELECTORS.listItem).remove();
    }
    updateCounter(num) {
        this.count = num || 0;
        const counters = document.querySelectorAll(`[${this.SELECTORS.counter}]`);
        counters.forEach((counter) => {
            let htmlcounter = counter;
            if (this.count === 0) {
                htmlcounter.innerText = '0';
                //htmlcounter.style.display = 'none';
                location.reload();
            }
            else {
                //htmlcounter.removeAttribute('style');
                htmlcounter.innerText = this.count.toString();
            }
            counter.setAttribute(this.SELECTORS.counter, this.count.toString());
        });
    }
    listenForCartAdded() {
        console.log('LISTEN');
        // workaround to remove product from wishlist in wishlist-show page
        //customEventBus.on('minicart:update', (data: any) => {
        customEventBus.on('cartCookie:update', (data) => {
            //const listitem = document.querySelector(this.SELECTORS.listItem + '[data-option-pid="' + data.pid + '"]');
            let listitem = document.querySelector(`.product-tile[data-option-pid="${data.pid}"]`);
            console.log('BUS', `.product-tile[data-option-pid="${data.pid}"]`, data.pid);
            if (listitem) {
                this.wishlistFlow();
                // const removeBtn = listitem.querySelector('[data-component="addToWishlist"][data-isinwishlist="true"]') as HTMLElement;
                // removeBtn.click();
            }
        });
    }
}
